import { ResultWithOptionalError } from '../../types/generic/results';
import { showErrorToast } from '../../utils/view/toast';
import { getDirectoryHandler } from '../user/multiUserStorage';

export const getDirectoryPermission = async (
  dirHandle?: FileSystemDirectoryHandle
) => {
  const options = { mode: 'readwrite' };

  if (!dirHandle) {
    return 'No Directory Handler';
  }

  try {
    // @ts-ignore
    const queryPermission = await dirHandle.queryPermission(options);
    // @ts-ignore
    const requestPermission = await dirHandle.requestPermission(options);

    if (queryPermission === 'granted' || requestPermission === 'granted') {
      return '';
    } else {
      return 'Permission denied';
    }
  } catch (err) {
    return 'Unable to get permission';
  }
};

export const selectDirectory = async () => {
  let error = '';
  const directoryHandler = await (window as any)
    .showDirectoryPicker({
      id: 'backupDir',
      mode: 'readwrite',
      startIn: 'documents',
    })
    .catch((err: string) => {
      console.log(err);
      error = 'Permission denied: Backup will not be saved';
    });

  return {
    error,
    directoryHandler,
  };
};

export const loadAndGetDirectoryPermission = async (): Promise<ResultWithOptionalError<FileSystemDirectoryHandle>> => {
  const result: ResultWithOptionalError<FileSystemDirectoryHandle> =
    await getDirectoryHandler();
  if (result.error || !result.data) {
    showErrorToast(result.error?.message ?? '');
    return result
  }
  const error = await getDirectoryPermission(result.data);
  if (error.length) {
    showErrorToast(error);
    return {
      error: new Error(error)
    }
  }

  return result
};
